<template>
    <Result status="403" title="403" :sub-title="$t('views.error.403.title')">
        <template #extra>
            <Button class="btn-primary" @click="back">{{ $t("button.back") }}</Button>
        </template>
    </Result>
</template>

<script>
import { defineComponent } from "vue";
import { Result, Button } from "ant-design-vue";

export default defineComponent({
    components: {
        Result,
        Button,
    },
    data() {
        return {};
    },
    methods: {
        back() {
            const url = this.$route.query?.url || "/";
            this.$router.push({ path: url });
        },
    },
    created() {},
});
</script>
